import { useTranslation } from "react-i18next";
import SectionHeader from "../../../util/component/SectionHeader";
import LiveMonitoring from "./cashback/sections/LiveMonitoring";
import { Box, Tab, Tabs } from "@mui/material";
import { useEffect } from "react";
import { useRouteMatch } from "../utils/RouteMatch";
import { Link, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import ThresholdConfiguration from "./cashback/sections/ThresholdsConfiguration";
import EmptyLiveMonitoring from "./cashback/sections/EmptyLiveMonitoring";
import { CASHBACK_CONFIGURE_THRESHOLD, CASHBACK_VIEW_LIVE_MONITORING, CASHBACK_VIEW_THRESHOLD } from "../utils/FinanceScope";
import NotAuthorizedDialog from "../../authentication/component/NotAuthorizedDialog";
import { useHasScope } from "../../../config/globalConfig";

const PageCashback = () => {
    const { t } = useTranslation(["finance"], { keyPrefix: "cashback" });
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const dateFrom = queryParams.get('dateFrom');
    const dateTo = queryParams.get('dateTo');
    const hasScope = useHasScope;
    let ROUTING = [{ id: 2, name: t('tabs.threshold-wizard'), pathname: '/finance/cashback/threshold-wizard', visible: false }];

    if (hasScope(CASHBACK_VIEW_LIVE_MONITORING) && hasScope(CASHBACK_VIEW_THRESHOLD)) {
        ROUTING = [
            { id: 0, name: t('tabs.monitoring'), pathname: '/finance/cashback', visible: true },
            { id: 1, name: t('tabs.configuration'), pathname: '/finance/cashback/thresholdsconfiguration', visible: true },
            { id: 2, name: t('tabs.threshold-wizard'), pathname: '/finance/cashback/threshold-wizard', visible: false }
        ];
    } else if (hasScope(CASHBACK_VIEW_LIVE_MONITORING)) {
        ROUTING = [
            { id: 0, name: t('tabs.monitoring'), pathname: '/finance/cashback', visible: true },
            { id: 1, name: t('tabs.threshold-wizard'), pathname: '/finance/cashback/threshold-wizard', visible: false }
        ];
    } else if (hasScope(CASHBACK_VIEW_THRESHOLD)) {
        ROUTING = [
            { id: 0, name: t('tabs.configuration'), pathname: '/finance/cashback/thresholdsconfiguration', visible: true },
            { id: 1, name: t('tabs.threshold-wizard'), pathname: '/finance/cashback/threshold-wizard', visible: false }
        ];
    }



    const routeMatch = useRouteMatch(ROUTING.map(it => it.pathname));
    const currentTab = routeMatch?.pattern?.path;

    useEffect(() => {
        if (location.pathname === "/finance/cashback/livemonitoring") {
            navigate("/finance/cashback");
        }
    })

    console.log({liveMonitoring:hasScope(CASHBACK_VIEW_LIVE_MONITORING )})
    console.log({configureThreshold:hasScope(CASHBACK_CONFIGURE_THRESHOLD )})
    
    return (
        hasScope(CASHBACK_VIEW_LIVE_MONITORING) || hasScope(CASHBACK_VIEW_THRESHOLD) ?
            <Box>
                <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')} />
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={currentTab ? currentTab : false}>
                        {ROUTING.filter(it => it.visible).map(it => <Tab key={it.id} label={it.name} value={it.pathname} to={it.pathname} component={Link} />)}
                    </Tabs>
                </Box>
                <Routes>
                    {hasScope(CASHBACK_VIEW_LIVE_MONITORING) ?
                        !(dateFrom && dateTo) ?
                            <Route path="/" element={<EmptyLiveMonitoring />} /> : <Route path="/" element={<LiveMonitoring />} />

                        : null
                    }
                    {hasScope(CASHBACK_VIEW_THRESHOLD) ?
                        <Route path="/thresholdsconfiguration" element={<ThresholdConfiguration />} />
                        : null
                    }
                </Routes>
            </Box>
            : <NotAuthorizedDialog />
    );

};

export default PageCashback;